<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }"
        aria-labelledby="mobile-navigation-toggler" itemscope itemtype="https://schema.org/SiteNavigationElement">
        <!--<div v-show="isNavigationInitialized">
            <ul class="breadcrumb d-block px-3 py-0">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item" @click="slideTo(null, true)">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>

                <li class="breadcrumb-item" v-for="breadcrumb in breadcrumbs" @click="slideTo(breadcrumb.parent, true)">
                    {{ breadcrumb.name }}
                </li>
            </ul>
            <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
                <li class="ddown" v-if="dataContainer1.parent" @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                    <span class="nav-direction btn-up">
                        <i class="fa fa-lg fa-level-up" aria-hidden="true"></i>
                    </span>
                </li>

                <li class="ddown" v-for="category in dataContainer1.categories">
                    <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                        <i class="fa fa-lg fa-caret-right" aria-hidden="true"></i>
                    </span>
                </li>
                <template v-if="dataContainer1.categories[0]">
                    <li class="ddown" v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
<template v-else-if="dataContainer1.parent">
                    <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
</ul>

<ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
    <li class="ddown" v-if="dataContainer2.parent"
        @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
        <span class="nav-direction btn-up">
            <i class="fa fa-lg fa-level-up" aria-hidden="true"></i>
        </span>
    </li>

    <li class="ddown" v-for="category in dataContainer2.categories">
        <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
        <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
            <i class="fa fa-lg fa-caret-right" aria-hidden="true"></i>
        </span>
    </li>
    <template v-if="dataContainer2.categories[0]">
                    <li class="ddown" v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
    <template v-else-if="dataContainer2.parent">
                    <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
</ul>
</div>

<template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>

            <loading-animation></loading-animation>
        </template>-->

        <ul class="breadcrumb mobile-navigation__breadcrumb" v-if="isNavigationInitialized">
            <li class="btn-close" @click="closeNavigation()" :aria-label="$translate('Ceres::Template.closeIcon')">
                <svg width="27" height="26">
                    <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </li>

            <li class="breadcrumb-item"
                v-if="$store.state.navigation.currentCategory && $store.state.navigation.currentCategory.details">
                {{ $store.state.navigation.currentCategory.details[0].name }}
            </li>
            <li v-else class="breadcrumb-item">
                Navigation
            </li>
        </ul>

        <ul class="mobile-navigation__wrapper" v-if="isNavigationInitialized">
            <li class="mobile-navigation__navtree" v-for="item in $store.state.navigation.tree">
                <a v-if="item.children && item.children.length" href="#" @click="toggleChilds(item.id)"
                    class="mobile-navigation__link"
                    :class="{ 'active': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == item.id) || ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.parentCategoryId == item.id) || openCategories.includes(item.id) }">
                    <span v-if="icon1CatId === item.id" v-html="JSON.parse(icon1)"></span>
                    <span v-if="icon2CatId === item.id" v-html="JSON.parse(icon2)"></span>
                    <span v-if="icon3CatId === item.id" v-html="JSON.parse(icon3)"></span>
                    <span v-if="icon4CatId === item.id" v-html="JSON.parse(icon4)"></span>
                    <span v-if="icon5CatId === item.id" v-html="JSON.parse(icon5)"></span>
                    <span v-if="icon6CatId === item.id" v-html="JSON.parse(icon6)"></span>
                    <span v-if="icon7CatId === item.id" v-html="JSON.parse(icon7)"></span>
                    <span v-if="icon8CatId === item.id" v-html="JSON.parse(icon8)"></span>
                    <span v-if="icon9CatId === item.id" v-html="JSON.parse(icon9)"></span>
                    <span v-if="icon10CatId === item.id" v-html="JSON.parse(icon10)"></span>
                    <span v-if="icon11CatId === item.id" v-html="JSON.parse(icon11)"></span>
                    <span v-if="icon12CatId === item.id" v-html="JSON.parse(icon12)"></span>
                    {{ item.details[0].name }}
                </a>
                <a v-else :href="getRelativeUrl(item.details[0].nameUrl)" class="mobile-navigation__link"
                    :class="{ 'active': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == item.id) || ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.parentCategoryId == item.id) || openCategories.includes(item.id) }">
                    <span v-if="icon1CatId === item.id" v-html="JSON.parse(icon1)"></span>
                    <span v-if="icon2CatId === item.id" v-html="JSON.parse(icon2)"></span>
                    <span v-if="icon3CatId === item.id" v-html="JSON.parse(icon3)"></span>
                    <span v-if="icon4CatId === item.id" v-html="JSON.parse(icon4)"></span>
                    <span v-if="icon5CatId === item.id" v-html="JSON.parse(icon5)"></span>
                    <span v-if="icon6CatId === item.id" v-html="JSON.parse(icon6)"></span>
                    <span v-if="icon7CatId === item.id" v-html="JSON.parse(icon7)"></span>
                    <span v-if="icon8CatId === item.id" v-html="JSON.parse(icon8)"></span>
                    <span v-if="icon9CatId === item.id" v-html="JSON.parse(icon9)"></span>
                    <span v-if="icon10CatId === item.id" v-html="JSON.parse(icon10)"></span>
                    <span v-if="icon11CatId === item.id" v-html="JSON.parse(icon11)"></span>
                    <span v-if="icon12CatId === item.id" v-html="JSON.parse(icon12)"></span>
                    {{ item.details[0].name }}
                </a>
                <span v-if="item.children && item.children.length" @click="toggleChilds(item.id)"
                    class="mobile-navigation__open-sub"><i
                        :class="{ 'fa-chevron-down': openCategories.includes(item.id), 'fa-chevron-right': !openCategories.includes(item.id) }"
                        class="fa no-dia"></i></span>
                <ul v-if="item.children && item.children.length" class="mobile-navigation__child-list"
                    :class="{ 'is-open': openCategories.includes(item.id) }">
                    <li>
                        <a :href="getRelativeUrl(item.details[0].nameUrl)"
                            class="mobile-navigation__link mobile-navigation__link--bold">{{
                                $translate("Weberbuero::Template.mobileNavShowAll") }}</a>
                    </li>
                    <li v-for="child in item.children"
                        :class="{ 'is-open--li': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == child.id) || ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.parentCategoryId == child.id) || openCategories.includes(child.id) }">
                        <a v-if="child.children && child.children.length" href="#" @click="toggleChilds(child.id)"
                            class="mobile-navigation__link" itemprop="name"
                            :class="{ 'active': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == child.id) || ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.parentCategoryId == child.id) }">

                            {{ child.details[0].name }}
                        </a>
                        <a v-else :href="getRelativeUrl(item.details[0].nameUrl, child.details[0].nameUrl)"
                            class="mobile-navigation__link" itemprop="name"
                            :class="{ 'active': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == child.id) || ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.parentCategoryId == child.id) }">

                            {{ child.details[0].name }}
                        </a>
                        <span v-if="child.children && child.children.length" @click="toggleChilds(child.id)"
                            class="mobile-navigation__open-sub"><i
                                :class="{ 'fa-chevron-down': openCategories.includes(child.id), 'fa-chevron-right': !openCategories.includes(child.id) }"
                                class="fa no-dia"></i></span>
                        <ul v-if="child.children && child.children.length" class="mobile-navigation__childChild-list"
                            :class="{ 'is-open': openCategories.includes(child.id) }">
                            <li>
                                <a :href="getRelativeUrl(item.details[0].nameUrl, child.details[0].nameUrl)"
                                    class="mobile-navigation__link mobile-navigation__link--bold">{{
                                        $translate("Weberbuero::Template.mobileNavShowAll") }}</a>
                            </li>
                            <li v-for="childChild in child.children">
                                <a :href="getRelativeUrl(item.details[0].nameUrl, child.details[0].nameUrl, childChild.details[0].nameUrl)"
                                    class="mobile-navigation__link" itemprop="name"
                                    :class="{ 'active': ($store.state.navigation.currentCategory != null && $store.state.navigation.currentCategory.id == childChild.id) }">{{
                                        childChild.details[0].name }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

        <div class="mobile-nav__contact--entries">
            <div class="mobile-nav__contact--entry phone"><svg width="17" height="17">
                    <use xlink:href="#svg_phone" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg><a href="tel:+498709927788">+49 (0) 8709 / 927788</a></div>
            <div class="mobile-nav__contact--entry"><svg>
                    <use xlink:href="#svg_mail" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg><a href="mailto:info@weberbuero.de">info@weberbuero.de</a></div>
            <div class="mobile-nav__contact--entry"><svg>
                    <use xlink:href="#svg_form" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg><a href="https://weberbuero.zendesk.com/hc/de/requests/new">{{
                    $translate("Weberbuero::Template.footerContactForm") }}</a></div>
        </div>
    </div>
</template>

<script>
import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean,
        prop1: Object,
        prop1Children: Array,
        prop2: Object,
        prop2Children: Array,
        prop3: Object,
        prop3Children: Array,

        icon1: String,
        icon2: String,
        icon3: String,
        icon4: String,
        icon5: String,
        icon6: String,
        icon7: String,
        icon8: String,
        icon9: String,
        icon10: String,
        icon11: String,
        icon12: String,

        icon1CatId: Number,
        icon2CatId: Number,
        icon3CatId: Number,
        icon4CatId: Number,
        icon5CatId: Number,
        icon6CatId: Number,
        icon7CatId: Number,
        icon8CatId: Number,
        icon9CatId: Number,
        icon10CatId: Number,
        icon11CatId: Number,
        icon12CatId: Number,
    },

    data() {
        return {
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null,
            openCategories: [],
            propCatsAdded: false
        };
    },

    computed:
    {
        breadcrumbs() {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length) {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created() {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted() {
        this.addEventListener();
    },

    methods:
    {
        getRelativeUrl(nameUrl, nameUrl2, nameUrl3) {
            // nameUrl ist ebene 1, nameUrl2 ebene 2, nameUrl3 ebene 3
            nameUrl2 = nameUrl2 || "";
            nameUrl3 = nameUrl3 || "";

            if (nameUrl2 === "") {
                return "/" + nameUrl
            } else if (nameUrl3 === "") {
                return "/" + nameUrl + "/" + nameUrl2
            } else {
                return "/" + nameUrl + "/" + nameUrl2 + "/" + nameUrl3
            }
        },

        createNewNav() {
            // this.navtree

            // if(!this.propCatsAdded){
            //     this.propCatsAdded = true;

            for (let key in this.prop1Children) {
                this.prop1Children[key].children = [];
            }
            for (let key in this.prop2Children) {
                this.prop2Children[key].children = [];
            }
            for (let key in this.prop3Children) {
                this.prop3Children[key].children = [];
            }
            this.prop1.children = this.prop1Children;
            this.prop2.children = this.prop2Children;
            this.prop3.children = this.prop3Children;

            //let navTreeCats = this.navigationTree;
            //const newNavTreeCats = navTreeCats.push(this.prop1, this.prop2, this.prop3);
            //this.navigationTree.categories = newNavTreeCats;
            let alreadyInNavigation = this.navigationTree.find(navItem => navItem.id === this.prop1.id);
            if (!alreadyInNavigation) {
                const newNavTree = [...this.navigationTree, this.prop1, this.prop2, this.prop3];
                this.$store.commit("setNavigationTree", newNavTree);
            }
            // }

            //this.$store.commit("setNavigationTree", this.navigationTree);
        },

        addEventListener() {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint)) {
                this.loadInitialTree();
            }
        },

        loadInitialTree() {
            if (this.navigationTree.length <= 0) {
                const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response => {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            } else {
                this.dataContainer1.parent = null;
                this.dataContainer1.categories = this.navigationTree;
                this.isNavigationInitialized = true;

                if (this.$store.state.navigation.currentCategory != null) {
                    this.openCategories.push(this.$store.state.navigation.currentCategory.id);
                    this.openCategories.push(this.$store.state.navigation.currentCategory.parentCategoryId);

                    if (this.$store.state.navigation.currentCategory.parent != null) {
                        this.openCategories.push(this.$store.state.navigation.currentCategory.parent.parentCategoryId);
                    }
                }

                let _this = this;
                setTimeout(function () {
                    _this.createNewNav();
                }, 500);

                this.dataContainer1 = this.navigationTree;
            }
        },

        initNavigation() {
            //this.$store.dispatch("initNavigationTree", this.navigationTreeData); // initNavigationTree  loadNavigationTree

            if (this.initialCategory && this.initialCategory.id) {
                if (this.initialCategory.linklist === "N") {
                    this.$store.commit("setCurrentCategory", this.initialCategory);
                }
                else {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }

            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;

            if (this.$store.state.navigation.currentCategory != null) {
                this.openCategories.push(this.$store.state.navigation.currentCategory.id);
                this.openCategories.push(this.$store.state.navigation.currentCategory.parentCategoryId);

                if (this.$store.state.navigation.currentCategory.parent != null) {
                    this.openCategories.push(this.$store.state.navigation.currentCategory.parent.parentCategoryId);
                }
            }

            let _this = this;
            setTimeout(function () {
                _this.createNewNav();
            }, 500);

            this.dataContainer1 = this.navigationTree;
        },

        initialSlide(currentCategory) {
            if (currentCategory) {
                if (currentCategory.children) {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent) {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        toggleChilds(catId) {

            // anhand des states das icon austauschen und die child list ein/ausblenden

            if (this.openCategories.indexOf(catId) > -1) {

                let index = this.openCategories.indexOf(catId);
                this.openCategories.splice(index, 1);

            } else {
                this.openCategories.push(catId);
            }

        },

        slideTo(category, back) {
            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer) {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId) {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId)) {
                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response => {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId)) {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId) {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers) {
                if (category) {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree) {
            for (const cat of tree) {
                if (categoryId === cat.id) {
                    return cat;
                }
                else if (cat.children) {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat) {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation() {
            this.$store.commit("setIsMobileNavigationOpen", false);
            $('.mobile-navigation__overlay').hide();
        },

        getCategoryUrl(url) {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return prefix + url;
        }
    },

    directives:
    {
        menu: {
            bind(el) {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) => {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) => {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
                    $(".mainmenu").removeClass((index, className) => {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
</script>
